import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-grey-lighten-4 border rounded-lg px-4 py-3 mb-4" }
const _hoisted_2 = { class: "text-subtitle-1 font-weight-bold text-grey-darken-4" }
const _hoisted_3 = { class: "text-caption text-disabled" }
const _hoisted_4 = { class: "d-flex justify-space-between align-center mt-3" }
const _hoisted_5 = { class: "text-h6 font-weight-bold text-grey-darken-4 tabular-nums" }

import { ref, computed } from 'vue';
import { formatCurrency } from '@/services/utils';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import type { DisbursementRowView } from '../settlement/composables/useDisbursements';


export default /*@__PURE__*/_defineComponent({
  __name: 'FeeRecipientSubmitConfirmDialog',
  setup(__props, { expose: __expose }) {

// Mirrors liens/LienPushConfirmDialog.vue's structure/content — same payee summary
// card + amount + "creates a QuickBooks check" copy — so submitting a fee recipient
// disbursement previews the same way submitting a lien does.
const isVisible = ref(false);
const row = ref<DisbursementRowView | null>(null);
let resolvePromise: ((value: boolean) => void) | null = null;

const isRetry = computed(() => row.value?.state === 'error');

/** Open the confirmation for a disbursement row; resolves true when confirmed. */
function open(target: DisbursementRowView): Promise<boolean> {
  row.value = target;
  isVisible.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
}

function confirm(): void {
  isVisible.value = false;
  resolvePromise?.(true);
  resolvePromise = null;
}

function cancel(): void {
  isVisible.value = false;
  resolvePromise?.(false);
  resolvePromise = null;
}

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isVisible).value = $event)),
    "max-width": "460",
    "data-cy": "fee-recipient-submit-confirm-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Submit Disbursement to QuickBooks", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-body-2 text-medium-emphasis mb-4" }, " This will create a check in QuickBooks for: ", -1)),
              _createElementVNode("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Recipient", -1)),
                _createElementVNode("div", _hoisted_2, _toDisplayString(row.value?.recipientName), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(row.value?.typeLabel), 1),
                _createElementVNode("div", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-body-2 text-medium-emphasis" }, "Amount", -1)),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatCurrency)(row.value?.amount ?? 0)), 1)
                ])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-caption text-disabled mb-0 leading-[1.6]" }, [
                _createTextVNode(" The disbursement status will update to "),
                _createElementVNode("strong", null, "Submitted"),
                _createTextVNode(" and a QuickBooks check reference will be recorded. This action can be undone while the check has not been reconciled. ")
              ], -1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "pa-6" }, {
            default: _withCtx(() => [
              _createVNode(LlSecondaryButton, {
                "data-cy": "fee-recipient-submit-confirm-cancel",
                onClick: cancel
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(LlSecondaryButton, {
                color: "primary",
                "data-cy": "fee-recipient-submit-confirm-ok",
                onClick: confirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isRetry.value ? 'Retry Submit' : 'Submit to QuickBooks'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})